module.exports = __webpack_public_path__ + "img/lmdc-logo.be268f5c.png";